import { render, staticRenderFns } from "./MaterialOutboundAdd.vue?vue&type=template&id=6a4c486e&scoped=true"
import script from "./MaterialOutboundAdd.vue?vue&type=script&lang=js"
export * from "./MaterialOutboundAdd.vue?vue&type=script&lang=js"
import style0 from "./MaterialOutboundAdd.vue?vue&type=style&index=0&id=6a4c486e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c486e",
  null
  
)

export default component.exports